import React from 'react';
import PropTypes from 'prop-types';

import {
	makeStyles,
	Grid
} from '@material-ui/core';

import PatternMetricsCard from "./PatternMetricsCard";

const styles = makeStyles(theme => ({
	itemContainer: {
		border: "1px solid #D9DCDD",
		padding: 8,
		borderRadius: 6,
		width: "100%"
	},

	gap: {
		gap: "10px"
	},

	alertsCard: {
		color: "#E81717"
	},

	otherCards: {
		color: "#99CBD2"
	},
}));

function PatternMetrics(props) {
	let classes = styles(),
		{data} = props;

	return (
		<Grid container
			justifyContent='space-between'
			wrap="nowrap"
			direction='row'
			className={classes.gap}>
			<Grid item className={classes.itemContainer}>
				<PatternMetricsCard
					label="Alerts"
					value={data.actionables}
					icon={["fas", "exclamation-triangle"]}
					colorClass={classes.alertsCard} />
			</Grid>
			<Grid item className={classes.itemContainer}>
				<PatternMetricsCard
					label="Discussions"
					value={data.discussions}
					icon={["fas", "comment-alt-dots"]} 
					colorClass={classes.otherCards} />
			</Grid>
			<Grid item className={classes.itemContainer}>
				<PatternMetricsCard
					label="Emails"
					value={data.emails}
					icon={["fas", "envelope"]}
					colorClass={classes.otherCards} />
			</Grid>
			<Grid item className={classes.itemContainer}>
				<PatternMetricsCard
					label="Chats"
					value={data.chats}
					icon={["fas", "comments-alt"]}
					colorClass={classes.otherCards} />
			</Grid>
		</Grid>
	);
}

PatternMetrics.propTypes = {
	data: PropTypes.object
};

export default PatternMetrics;